import type { WP_REST_API_Page } from 'wp-types';

export type WpPage = WP_REST_API_Page;
export type WpPagePreview = Pick<WpPage, 'id' | 'slug' | 'title' | 'menu_order' | 'link'>;

export default (fetch: typeof $fetch) => ({
  getBySlug: async (slug: string) => {
    const response = await fetch<WpPage[]>('/wp/v2/pages', {
      query: {
        slug,
        acf_format: 'standard'
      }
    });

    return response?.[0];
  },

  getPagePreviewsByParentId: async (parentId: string) => {
    const response = await fetch<WpPagePreview[]>('/wp/v2/pages', {
      query: {
        parent: parentId,
        acf_format: 'standard',
        _fields: 'id,slug,title,menu_order,link',
        _embed: true
      }
    });

    return response;
  }
});
